import React from 'react';
import type { IconName } from '@usealloy/component-library';
import { Box, Icon } from '@usealloy/component-library';
import { CardContentContainer, CardContentText } from './styles';


type CardContentProps = {
  iconName: IconName;
  title: string;
  text: string;
  width?: number;
};

const CardContent: React.FC<CardContentProps> = ({
  iconName,
  title,
  text,
  width,
}) => (
  <CardContentContainer>
    <Box
      direction="column"
      gap={2}
      justifyContent="center"
      style={{
        height: '100%',
        width: width ?? 375,
      }}
    >
      <Icon size="xl" icon={iconName} />
      <CardContentText weight={700}>
        {title}
      </CardContentText>
      <CardContentText>
        {text}
      </CardContentText>
    </Box>
  </CardContentContainer>
);

export default CardContent;
